import { Button, Col, Form, Input, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function FileForEviction({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? "" : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="File for eviction" />
          </Col>
          <Col span={24}>
            <Form.Item
              label="Tenants birthdates - put name before each date"
              name="tenantBirthDate"
            >
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Property owner name" name="propertyName">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Monthly Rental amount" name="monthlyRentalAmount">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <h3 className="red-info-heading">
              by checking off this item you will notify the broker to file for
              eviction
            </h3>
          </Col>
          <Col span={24}>
            <p>
              Fill in all of these blanks to fill in the eviction spreadsheet
            </p>
          </Col>
          <Col span={24}>
            <h3 className="red-info-heading">
              Go to this link and upload the following documents
            </h3>
          </Col>
          <Col span={24}>
            <p className="red-info-heading">
              Go to this link and upload the following documents
            </p>
          </Col>
          <Col span={24}>
            <p className="red-info-heading">
              -create a folder for each address and label with address
            </p>
          </Col>
          <Col span={24}>
            <p className="red-info-heading">
              -green slip - make sure it is for this date
            </p>
          </Col>
          <Col span={24}>
            <p className="red-info-heading">-pay quit notice</p>
          </Col>
          <Col span={24}>
            <p className="red-info-heading">-tenant lease</p>
          </Col>
          <Col span={24}>
            <h3 className="yellow-info-text">
              Send this message to the property owner
            </h3>
          </Col>
          <Col span={24}>
            <p>
              We are in the process of filing for eviction on your tenant. We
              anticipate we will have a hearing in the next week. Once the
              hearing is complete we will update you with the status. We
              appreciate your patience as we work through this process.
            </p>
          </Col>
          <Col span={24}>
            <p>
              This link is to the eviction spreadsheet so you can see updates
            </p>
          </Col>
          <Col span={24}>
            <p className="onclick-text">eviction sheet</p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default FileForEviction;
